let handedOffTracks = null;

export const handOffPreviewTracks = tracks => {
	handedOffTracks = tracks.filter(Boolean);
};

export const takePreviewTracks = () => {
	const tracks = handedOffTracks || [];

	handedOffTracks = null;

	return tracks;
};

export const discardPreviewTracks = () => {
	takePreviewTracks().forEach(track => track.stop());
};
